import type { GenplanPlot } from '../model/types';
import { getPlotStatusPresentation } from './getPlotStatusPresentation';

const rubFormatter = new Intl.NumberFormat('ru-RU', {
  maximumFractionDigits: 0,
});

const areaFormatter = new Intl.NumberFormat('ru-RU', {
  maximumFractionDigits: 2,
});

export const plotPriceRatesRub = {
  withoutContractor: 500_000,
  withContractor: 520_000,
} as const;

export function formatAreaSotka(area: number): string {
  return `${areaFormatter.format(area)} сот.`;
}

export function formatRub(value: number): string {
  return `${rubFormatter.format(value)} ₽`;
}

function getCurrentRateRub(plot: GenplanPlot): number | undefined {
  if (plot.current)
    return plot.current.availability === 'available' && !plot.current.formatNeedsReview
      ? plot.current.rateRub
      : undefined;
  if (plot.status.kind === 'price-per-sotka' || plot.status.kind === 'free') {
    return plotPriceRatesRub.withoutContractor;
  }

  if (plot.status.kind === 'price-per-sotka-with-contractor') {
    return plotPriceRatesRub.withContractor;
  }

  return undefined;
}

export function getCurrentTotalPriceRub(plot: GenplanPlot): number | undefined {
  const rate = getCurrentRateRub(plot);

  return typeof rate === 'number' ? Math.round(plot.areaSotka * rate) : undefined;
}

export function formatOptionalPrice(plot: GenplanPlot): string | undefined {
  const currentTotal = getCurrentTotalPriceRub(plot);

  return typeof currentTotal === 'number' ? formatRub(currentTotal) : undefined;
}

export function getPlotAriaLabel(plot: GenplanPlot): string {
  const parts = [
    `Участок ${plot.displayNumber}`,
    `кадастровый номер ${plot.cadastralNumber}`,
    formatAreaSotka(plot.areaSotka),
    formatOptionalPrice(plot),
    getPlotStatusPresentation(plot.status.kind).ariaLabel,
  ].filter(Boolean);

  return parts.join(', ');
}
